var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"site chat"},[_c('article',{staticClass:"content-area"},[_vm._t("navheader"),_c('main',[_vm._t("content")],2)],2),_c('site-aside')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }